// Improved CPB JavaScript with better performance and maintainability

window.PXUTheme = window.PXUTheme || {};
window.PXUTheme.contentCreator = window.PXUTheme.contentCreator || {};

// Accordion module - simplified and more efficient
window.PXUTheme.contentCreator.accordion = {
  init() {
    const accordionSelectors = '.accordion > dt > a, [data-cc-accordion] > dt > a';
    const $accordionHeadings = $(accordionSelectors);
    
    if (!$accordionHeadings.length) return;
    
    // Set initial ARIA states
    $('.accordion > dd, [data-cc-accordion] > dd').attr('aria-hidden', true);
    $accordionHeadings.attr('aria-expanded', false);
    
    // Use event delegation for better performance
    $(document).on('click keydown', accordionSelectors, function(event) {
      if (event.type === 'keydown' && event.keyCode !== 13) return;
      
      const $this = $(this);
      const isExpanded = $this.attr('aria-expanded') === 'true';
      
      $this.attr('aria-expanded', !isExpanded);
      $this.parent().next().attr('aria-hidden', isExpanded);
      
      if (event.type === 'click') {
        event.preventDefault();
      }
    });
  },
  
  unload() {
    $(document).off('click keydown', '.accordion > dt > a, [data-cc-accordion] > dt > a');
  }
};

// Main CPB module
(function($) {
  'use strict';
  
  // Configuration constants
  const CONFIG = {
    UPDATE_THROTTLE: 200,
    CPB_LOAD_DELAY: 250,
    CLEANUP_DELAY: 1000,
    SHOP_PAY_INIT_DELAY: 0,
    PRICE_UPDATE_DELAY: 3000,
    FORM_CHANGE_DELAY: 450
  };
  
  // State management
  const state = {
    builder: null,
    panelsContainer: null,
    price: null,
    lastUpdateTime: 0,
    isUpdating: false,
    customPricesContainer: null,
    shopPayContainer: null,
    afterpayContainer: null,
    timeouts: new Map(),
    observers: new Map()
  };
  
  // Utility functions
  const utils = {
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    throttle(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    },
    
    clearTimeouts() {
      state.timeouts.forEach(timeout => clearTimeout(timeout));
      state.timeouts.clear();
    },
    
    clearObservers() {
      state.observers.forEach(observer => observer.disconnect());
      state.observers.clear();
    },
    
    setTimeout(callback, delay, key) {
      if (key && state.timeouts.has(key)) {
        clearTimeout(state.timeouts.get(key));
      }
      const timeout = setTimeout(callback, delay);
      if (key) state.timeouts.set(key, timeout);
      return timeout;
    }
  };
  
  // DOM management
  const dom = {
    initGlobals() {
      state.builder = $('#product-builder');
      state.panelsContainer = state.builder.find('.cpb-panels-container');
      state.price = state.panelsContainer.find('.cpb-product-price');
      
      return state.builder.length > 0;
    },
    
    moveDescription() {
      const $description = $('.product-block--description').first();
      const $personalizeButton = $('.personalize-it--js');
      
      const moveToTarget = () => {
        const $cpbDescription = $('.cpb-product-description');
        if ($cpbDescription.length && $description.length) {
          $cpbDescription.empty().append($description);
        }
      };
      
      if ($personalizeButton.length) {
        $personalizeButton.one('click', moveToTarget);
      } else {
        moveToTarget();
      }
    },
    
    createPriceComponents() {
      if (state.customPricesContainer) return; // Already created
      
      const $realPrice = state.panelsContainer.find('.cpb-product-price').last();
      if (!$realPrice.length) return;
      
      // Create price containers
      state.customPricesContainer = $('<div class="cpb-custom-prices-container">');
      const $customPriceContainer = $('<div class="cpb-custom-product-price-container">');
      const $customPrice = $('<span class="cpb-custom-product-price">');
      
      state.customPricesContainer.append($customPriceContainer);
      $customPriceContainer.append($customPrice);
      
      // Initial price update
      this.updatePrice($realPrice, $customPrice);
      
      // Watch for price changes with throttling
      if (!state.observers.has('price')) {
        const observer = new MutationObserver(
          utils.throttle(() => {
            this.updatePrice($realPrice, $customPrice);
            // Also update Shop Pay when price changes
            utils.setTimeout(() => shopPay.update(), 120, 'priceChangeShopPay');
          }, CONFIG.UPDATE_THROTTLE)
        );
        observer.observe($realPrice[0], {
          childList: true,
          characterData: true,
          subtree: true
        });
        state.observers.set('price', observer);
      }
      
      state.builder.attr('data-custom-product-price', true);
    },
    
    updatePrice($realPrice, $customPrice) {
      const priceText = $realPrice.text().trim();
      const cleanedPrice = priceText.replace(/[^0-9.,]/g, '');
      const noDecimalsPrice = cleanedPrice.replace(/\.\d+$/, '');
      const formattedPrice = `$${noDecimalsPrice}`;
      $customPrice.text(formattedPrice);
    },
    
    placeElements() {
      const $productTitle = state.panelsContainer.find('.cpb-product-title');
      const $ratingStars = $('.product__information .klaviyo-star-rating-widget');
      
      if (!$productTitle.length) {
        console.warn('CPB: Product title not found for element placement.');
        return;
      }
      
      // Place rating stars after title
      if ($ratingStars.length) {
        $productTitle.after($ratingStars);
      }
      
      // Place price container
      if (state.customPricesContainer) {
        const $targetForPrice = $ratingStars.length ? $ratingStars : $productTitle;
        $targetForPrice.after(state.customPricesContainer);
      }
      
      // Place Shop Pay widget after price container
      if (state.shopPayContainer && state.customPricesContainer) {
        state.customPricesContainer.after(state.shopPayContainer);
      }
    }
  };
  
  // Shop Pay management
  const shopPay = {
    init() {
      console.log('CPB: Adding Shop Pay Installments widget...');
      state.shopPayContainer = $('<div class="cpb-shopay-container">');
      state.afterpayContainer = $('<div class="cpb-afterpay-container">');
      state.shopPayContainer.append(state.afterpayContainer);
      console.log('CPB: Shop Pay container created, waiting for variant data');
    },
    
    getCurrentPrice() {
      // Try custom price first (this is the displayed discounted price)
      const $customPrice = $('.cpb-custom-product-price');
      if ($customPrice.length) {
        const priceText = $customPrice.text().trim();
        const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        if (!isNaN(price) && price > 0) {
          console.log('CPB: Got price from custom price element:', price);
          return price;
        }
      }
      
      // Fallback to real CPB price
      const $realPrice = state.panelsContainer?.find('.cpb-product-price').last();
      if ($realPrice?.length) {
        const priceText = $realPrice.text().trim();
        const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        if (!isNaN(price) && price > 0) {
          console.log('CPB: Got price from CPB price element:', price);
          return price;
        }
      }
      
      console.warn('CPB: Could not find current price');
      return null;
    },
    
    update: utils.throttle(function() {
      if (!state.shopPayContainer || state.isUpdating) return;
      
      const now = Date.now();
      if (now - state.lastUpdateTime < CONFIG.UPDATE_THROTTLE) return;
      
      state.isUpdating = true;
      state.lastUpdateTime = now;
      afterpay.update();
      
      console.log('CPB: Attempting to update Shop Pay widget...');
      
      const productId = state.builder.attr('data-product-id') || 
                       state.panelsContainer.attr('data-product-id') ||
                       window.cpbProductId;
      
      let variantId = this.findVariantId();
      
      console.log('CPB: Found IDs:', { productId, variantId });
      
      if (productId && !variantId) {
        this.fetchDefaultVariantId(productId);
      } else if (variantId) {
        this.createWidget(variantId);
      } else {
        console.warn('CPB: Could not find variant ID for Shop Pay widget');
        afterpay.update();
        state.isUpdating = false;
      }
    }, CONFIG.UPDATE_THROTTLE),
    
    findVariantId() {
      // Try multiple methods to find variant ID
      const selectors = [
        '[data-variant-id]',
        '[data-variant]',
        'select[name="id"]',
        'input[name="id"]'
      ];
      
      for (const selector of selectors) {
        const $element = state.builder.find(selector).first();
        if ($element.length) {
          const id = $element.attr('data-variant-id') || 
                   $element.attr('data-variant') || 
                   $element.val();
          if (id) return id;
        }
      }
      return null;
    },
    
    async fetchDefaultVariantId(productId) {
      console.log('CPB: Fetching default variant for product:', productId);
      
      const endpoints = this.getProductEndpoints(productId);
      
      for (const endpoint of endpoints) {
        try {
          console.log('CPB: Trying endpoint:', endpoint);
          const response = await fetch(endpoint);
          
          if (!response.ok) continue;
          
          const data = await response.json();
          const product = data.products?.[0] || data;
          
          if (product.variants?.length > 0) {
            const defaultVariant = product.variants[0];
            console.log('CPB: Found default variant:', defaultVariant.id);
            this.createWidget(defaultVariant.id);
            return;
          }
        } catch (error) {
          console.log(`CPB: Endpoint ${endpoint} failed:`, error.message);
        }
      }
      
      console.warn('CPB: All product API endpoints failed, using product ID as fallback');
      this.createWidget(productId);
    },
    
    getProductEndpoints(productId) {
      const endpoints = [
        `/products/${productId}.js`,
        `/products.json?ids=${productId}`
      ];
      
      // Try to get product handle from URL
      const handleMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
      if (handleMatch) {
        endpoints.unshift(`/products/${handleMatch[1]}.js`);
      }
      
      return endpoints;
    },
    
    createWidget(variantId) {
      const existingWidget = state.shopPayContainer.find('shopify-payment-terms').first();
      const existingId = existingWidget.attr('variant-id');
      const currentPrice = this.getCurrentPrice();
      const currentPriceKey = (typeof currentPrice === 'number' && isFinite(currentPrice) && currentPrice > 0)
        ? currentPrice.toFixed(2)
        : '';
      
      if (existingWidget.length && existingId === String(variantId)) {
        const renderedPriceKey = existingWidget.attr('data-cpb-price') || '';
        if (!currentPriceKey || renderedPriceKey === currentPriceKey) {
          console.log('CPB: Shop Pay widget already up to date:', { variantId, price: renderedPriceKey || 'unknown' });
          afterpay.update();
          state.isUpdating = false;
          return;
        }
        console.log('CPB: Price changed with same variant, refreshing Shop Pay in place:', {
          variantId,
          oldPrice: renderedPriceKey,
          newPrice: currentPriceKey
        });
        this.refreshWidgetInPlace(existingWidget[0], variantId, currentPrice);
        return;
      }
      
      console.log('CPB: Creating Shop Pay widget with variant ID:', variantId);

      const existingElement = existingWidget[0] || document.querySelector('shopify-payment-terms');

      if (existingElement) {
        this.cloneExistingWidget(existingElement, variantId, currentPrice, existingWidget);
      } else {
        this.createBasicWidget(variantId, currentPrice);
      }
    },

    applyWidgetPricing(widget, variantId, forcedPrice = null) {
      widget.setAttribute('variant-id', variantId);

      const currentPrice = (typeof forcedPrice === 'number' && isFinite(forcedPrice) && forcedPrice > 0)
        ? forcedPrice
        : this.getCurrentPrice();
      const fullPrice = currentPrice || 1979.00;

      const rawMeta = widget.getAttribute('shopify-meta');
      if (rawMeta) {
        try {
          const metaData = JSON.parse(rawMeta);
          metaData.variants = [{
            id: parseInt(variantId),
            price_per_term: (fullPrice / 4).toFixed(2),
            full_price: fullPrice.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).replace('.00', ''),
            eligible: true,
            available: true,
            number_of_payment_terms: 4
          }];
          widget.setAttribute('shopify-meta', JSON.stringify(metaData));
          console.log('CPB: Updated shopify-meta with actual price:', fullPrice);
        } catch (e) {
          console.warn('CPB: Could not parse existing shopify-meta:', e);
        }
      }

      widget.setAttribute('data-cpb-price', fullPrice.toFixed(2));
      return fullPrice;
    },

    refreshWidgetInPlace(existingWidgetEl, variantId, currentPrice = null) {
      if (!existingWidgetEl) {
        state.isUpdating = false;
        return;
      }

      this.applyWidgetPricing(existingWidgetEl, variantId, currentPrice);
      existingWidgetEl.setAttribute('data-instance-id', 'cpb-' + Math.random().toString(36).substr(2, 9));
      this.initializeWidget(existingWidgetEl);
      afterpay.update();
      state.isUpdating = false;
    },

    cloneExistingWidget(existingElement, variantId, currentPrice = null, replaceWidget = null) {
      console.log('CPB: Found existing shopify-payment-terms element, cloning it');
      
      const newWidget = existingElement.cloneNode(true);
      this.applyWidgetPricing(newWidget, variantId, currentPrice);
      
      // Generate new instance ID
      const newInstanceId = 'cpb-' + Math.random().toString(36).substr(2, 9);
      newWidget.setAttribute('data-instance-id', newInstanceId);

      if (replaceWidget?.length) {
        replaceWidget[0].replaceWith(newWidget);
      } else {
        state.shopPayContainer.prepend(newWidget);
      }
      if (state.afterpayContainer) {
        state.shopPayContainer.append(state.afterpayContainer);
      }
      afterpay.update();

      this.initializeWidget(newWidget);
      state.isUpdating = false;
    },
    
    createBasicWidget(variantId, currentPrice = null) {
      console.warn('CPB: No existing shopify-payment-terms element found to copy from');
      
      const shopPayInstallments = $('<shopify-payment-terms>');
      this.applyWidgetPricing(shopPayInstallments[0], variantId, currentPrice);
      
      state.shopPayContainer.empty().append(shopPayInstallments);
      if (state.afterpayContainer) {
        state.shopPayContainer.append(state.afterpayContainer);
      }
      afterpay.update();
      this.initializeWidget(shopPayInstallments[0]);
      
      console.log('CPB: Created basic shopify-payment-terms widget');
      state.isUpdating = false;
    },
    
    initializeWidget(widget) {
      // Dispatch initialization events
      const events = [
        new CustomEvent('shopify:payment-terms:loaded', { 
          bubbles: true,
          detail: { element: widget }
        }),
        new CustomEvent('shopify:section:load', { bubbles: true })
      ];
      
      events.forEach(event => document.dispatchEvent(event));
      
      // Force reflow
      widget.offsetHeight;
      
      console.log('CPB: Dispatched shopify-payment-terms initialization events');
    }
  };

  const afterpay = {
    ensurePlacement() {
      let placement = document.querySelector('[data-cpb-afterpay-placement]');
      if (placement) return placement;

      // Fallback only when original Liquid placement is unavailable
      const locale = document.documentElement.lang || 'en-US';
      const currency = window.Shopify?.currency?.active || 'USD';

      placement = document.createElement('square-placement');
      placement.setAttribute('data-mpid', '48578bf7-7484-47cb-b383-3639679803f2');
      placement.setAttribute('data-placement-id', 'f7505cf9-12dc-4c24-9193-f4e1fe7cb599');
      placement.setAttribute('data-page-type', 'product');
      placement.setAttribute('data-currency', currency);
      placement.setAttribute('data-consumer-locale', locale);
      placement.setAttribute('data-is-eligible', 'true');
      placement.setAttribute('data-cpb-afterpay-placement', '');

      return placement;
    },

    updateAmount(placement) {
      const amount = shopPay.getCurrentPrice();
      if (typeof amount === 'number' && isFinite(amount) && amount > 0) {
        placement.setAttribute('data-amount', amount.toFixed(2));
      }
    },

    update() {
      if (!state.afterpayContainer?.length) return;

      const placement = this.ensurePlacement();
      if (!placement) return;

      this.updateAmount(placement);

      if (placement.parentElement !== state.afterpayContainer[0]) {
        state.afterpayContainer.empty().append(placement);
      }

      placement.style.display = 'block';
    }
  };
  
  // Badge management
  const badges = {
    addPreOrder() {
      const preorderText = window.cpbPreorderText;
      if (!preorderText) return;
      
      this.createBadge('preorder', preorderText, '100% Money Back Guarantee - Cancel anytime before shipping for full refund');
    },
    
    addBackOrder() {
      const backorderText = window.cpbBackorderText;
      if (!backorderText) return;
      
      this.createBadge('backorder', backorderText, 'Estimated restock date - subject to change');
    },
    
    createBadge(type, text, tooltip) {
      const badge = $(`
        <div class="cpb-${type}-badge" title="${tooltip}">
          <span class="dot" aria-hidden="true"></span>
          ${text}
        </div>
      `);
      
      // For backorder badges, place after Shop Pay widget if it exists
      if (type === 'backorder' && state.shopPayContainer) {
        state.shopPayContainer.after(badge);
      } 
      // For preorder badges, place after price container
      else if (type === 'preorder') {
        const target = state.customPricesContainer || state.panelsContainer.find('.cpb-product-price');
        if (target.length) {
          target.after(badge);
        }
      }
      // Fallback placement after price container
      else {
        const target = state.customPricesContainer || state.panelsContainer.find('.cpb-product-price');
        if (target.length) {
          target.after(badge);
        }
      }
    }
  };
  
  // UI management
  const ui = {
    removeNavigationButtons() {
      const removeButtons = () => {
        $('.cpb-product-actions button, .cpb-product-actions .cpb-actions-btn').each(function() {
          const buttonText = $(this).text().trim().toUpperCase();
          const navKeywords = ['PREVIOUS', 'NEXT', 'RESET', 'PREVIOUS TAB', 'NEXT TAB'];
          
          if (navKeywords.some(keyword => buttonText.includes(keyword))) {
            $(this).remove();
          }
        });
      };
      
      // Remove immediately and after delays
      removeButtons();
      utils.setTimeout(removeButtons, 500, 'navButtons1');
      utils.setTimeout(removeButtons, 1500, 'navButtons2');
    },
    
    handleOutOfStockOverlays() {
      utils.setTimeout(() => {
        $('.out-stock-wrapper').each(function() {
          const $wrapper = $(this);
          const $overlay = $wrapper.find('.out-stock-overlay span');
          const $img = $wrapper.find('img').first();
          
          if ($overlay.length && $img.length) {
            let productTitle = $img.attr('alt') || 'Product';
            productTitle = productTitle.replace(/\s*\([^)]*\)\s*$/g, '').trim();
            $overlay.text(`${productTitle} - OUT OF STOCK`);
          }
        });
      }, CONFIG.CLEANUP_DELAY, 'outOfStock');
    }
  };
  
  // Event management
  const events = {
    init() {
      this.watchForVariantChanges();
    },
    
    watchForVariantChanges() {
      // Listen for CPB events
      $(document).on('CPB_VARIANT_CHANGED CPB_PRODUCT_UPDATED', () => {
        console.log('CPB: CPB event detected, updating Shop Pay...');
        utils.setTimeout(() => shopPay.update(), 120, 'cpbEvent');
      });
      
      // Watch for form changes with heavy throttling
      const debouncedUpdate = utils.debounce(() => {
        console.log('CPB: Major form change detected, updating Shop Pay...');
        shopPay.update();
      }, CONFIG.FORM_CHANGE_DELAY);
      
      $(document).on('change', `${state.builder.selector} select, ${state.builder.selector} input[type="radio"], ${state.builder.selector} input[type="checkbox"]`, debouncedUpdate);
    }
  };
  
  // Cleanup management
  const cleanup = {
    execute() {
      utils.clearTimeouts();
      utils.clearObservers();
      
      // Remove event listeners
      $(document).off('CPB_VARIANT_CHANGED CPB_PRODUCT_UPDATED');
      $(document).off('change', `${state.builder?.selector || ''} select, ${state.builder?.selector || ''} input[type="radio"], ${state.builder?.selector || ''} input[type="checkbox"]`);
      
      // Clear state
      Object.keys(state).forEach(key => {
        if (key !== 'timeouts' && key !== 'observers') {
          state[key] = null;
        }
      });
    }
  };
  
  // Main initialization
  function initializeProductBuilder() {
    try {
      console.log('CPB: Product mounted event fired');
      
      // Clean up any existing instances
      cleanup.execute();
      
      // Initialize DOM globals
      if (!dom.initGlobals()) {
        console.error('CPB: Product builder not found');
        return;
      }
      
      // Initialize components in order
      dom.createPriceComponents();
      shopPay.init();
      dom.moveDescription();
      dom.placeElements();
      badges.addPreOrder();
      badges.addBackOrder();
      ui.removeNavigationButtons();
      ui.handleOutOfStockOverlays();
      events.init();
      
      // Initialize Shop Pay after CPB loads
      utils.setTimeout(() => {
        console.log('CPB: Waiting for CPB to fully load...');
        shopPay.update();
      }, CONFIG.CPB_LOAD_DELAY, 'cpbLoad');
      
      console.log('CPB: Initialization completed successfully');
      
    } catch (error) {
      console.error('CPB: Initialization error:', error);
    }
  }
  
  // Event listeners
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', initializeProductBuilder);
  $(window).on('beforeunload', cleanup.execute);
  
})(jQuery);
